var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{staticClass:"colorset-view",attrs:{"swipe-options":{ direction: 'vertical', threshold: 10 }},on:{"panmove":_vm.move,"panend":_vm.moveend}},[_c('ul',{},[_c('transition-group',{attrs:{"name":"fade"}},_vm._l((_vm.colorset.array),function(item,index){return _c('li',{key:(_vm.name + "-" + index),staticClass:"color-item",style:({background: _vm.itemCssColor(item),
        transform:
          'translate(' + _vm.itemCssLeft(index) + ',' + _vm.itemCssTop(index) + ') ' +
          'scale(' + _vm.itemCssWidth(index) + ',' + _vm.itemCssHeight(index) + ')',
        })})}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-832fa57e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorsetView.vue
// module id = null
// module chunks = 